let titleList = [
  {
    title: '硬件产品',
    path: '/hardware'
  },
  {
    title: '服务商',
    path: '/service'
  },
  {
    title: '关于我们',
    path: '/contact'
  },
]

export default titleList



// WEBPACK FOOTER //
// ./src/assets/conf/titleList.js